import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=58b7b0fb"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports